/**
 * @param {string} key
 * @param {string} configName
 * @returns {string}
 */
export default function getLocalization(configName, key) {
    if (
        typeof window.config === 'undefined' ||
        typeof window.config[configName] === 'undefined' ||
        typeof window.config[configName].localization === 'undefined' ||
        typeof window.config[configName].localization[key] === 'undefined'
    ) {
        return key;
    }

    return window.config[configName].localization[key];
}
